<template>
  <div class="">
    <b-button v-b-toggle.revenues class="btn btn-lg btn-collapse">
      {{ $t("revenues") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="revenues">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentRevenuesView"
              v-model="usersPrivilegeRevenus.establishmentRevenuesView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentRevenuesView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentRevenuesAdd"
              v-model="usersPrivilegeRevenus.establishmentRevenuesAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentRevenuesAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentRevenuesRefund"
              v-model="usersPrivilegeRevenus.establishmentRevenuesRefund"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentRevenuesRefund">{{
              $t("refund")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeRevenus",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeRevenus"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
